import { makeStyles } from 'tss-react/mui';

interface StylesProps {
  width?: string | number;
  height?: string | number;
}

export const useStyles = makeStyles<StylesProps>()((
  theme,
  { height, width },
) => {
  return {
    player: {
      display: 'block',
      width: width ? width : '100%',
      height: height ? height : '100%',
    },
  };
});
